export const graphMargin = 10
export const scrollBarSize = { x: 10, y: 10 }
export const toolTipMargin = { x: 20, y: 10 }
export const textStyle = {
	fontFamily: 'Noto Sans JP,sans-serif'
}
